/** @jsx jsx */
import { jsx, Styled } from 'theme-ui';
import React from 'react';

export const SearchContainer = React.forwardRef(({ header, ...props }, ref) => (
  <div
    ref={ref}
    sx={{
      position: header ? 'absolute' : 'relative',
      zIndex: header ? 100 : null,
      width: header ? ['100%', '34.5rem', '70rem'] : '100%',
      left: header ? [0, 'auto'] : null,
      right: header ? ['auto', '9.2rem'] : null,
      top: header ? ['5.8rem', null, '6.4rem'] : null,
      px: header ? ['1.4rem', 0] : null,
    }}
    {...props}
  />
));

export const ResultHeader = (props) => (
  <Styled.h4
    sx={{
      backgroundColor: '#5a6874',
      color: '#fff',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      px: '1.7rem',
      pb: '1.7rem',
      margin: 0,
      lineHeight: '2rem',
    }}
    {...props}
  />
);

export const HitsWrapper = ({ show, ...props }) => (
  <div
    sx={{
      display: show ? 'grid' : 'none',
      maxHeight: '80vh',
      overflow: 'scroll',
      zIndex: 1000,
      webkitOverflowScrolling: 'touch',
      boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
      bg: 'white',
      color: 'PrimaryDarkBlue',
      position: 'absolute',
      width: '100%',
      ul: {
        display: 'grid',
        gridGap: '1em',
        padding: '2rem 1.7rem 5rem',
        margin: '0',
        listStyleType: 'none',
        fontSize: '1.5rem',
        mark: {
          bg: '#ffffff',
        },
        a: {
          textDecoration: 'underline',
          fontWeight: 'bold',
          fontSize: '2rem',
          color: '#000',
          '&:hover': {
            textDecoration: 'underline',
          },
          mark: {
            bg: '#ffffff',
          },
        },
      },
    }}
    {...props}
  />
);

export const Form = (props) => (
  <form
    sx={{
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
      color: '#3e4a56',
    }}
    {...props}
  />
);

export const Input = ({ header, ...props }) => (
  <input
    sx={{
      outline: 'none',
      fontSize: '2.1rem',
      background: 'transparent',
      transition: '300ms',
      backgroundImage: 'url("data:image/svg+xml,%3Csvg%20stroke%3D%22%235a6874%22%20fill%3D%22%235a6874%22%20stroke-width%3D%220%22%20viewBox%3D%220%200%2024%2024%22%20class%3D%22css-1k9rjh5-SearchButton%22%20height%3D%221em%22%20width%3D%221em%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M15.5%2014h-.79l-.28-.27C15.41%2012.59%2016%2011.11%2016%209.5%2016%205.91%2013.09%203%209.5%203S3%205.91%203%209.5%205.91%2016%209.5%2016c1.61%200%203.09-.59%204.23-1.57l.27.28v.79l5%204.99L20.49%2019l-4.99-5zm-6%200C7.01%2014%205%2011.99%205%209.5S7.01%205%209.5%205%2014%207.01%2014%209.5%2011.99%2014%209.5%2014z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '24px',
      paddingLeft: '5rem',
      width: '100%',
      lineHeight: '5.2rem',
      backgroundPosition: '14px center',
      backgroundColor: '#fff',
      border: header ? '1.7rem solid #5a6874' : 0,
      borderRadius: '2px',
      // boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
    }}
    {...props}
  />
);
